import * as React from 'react';
import changeIsToastShown from '../actions/changeIsToastShown';
import hideToast, { TOAST_DIV_ID } from './hideToast';
import ReactDOM from 'react-dom';
import setTimerId from '../actions/setTimerId';
import Toast from '../components/Toast';
import type ToastItem from '../store/schema/ToastItem';

export const TOAST_TIMEOUT_IN_MILLISECONDS: number = 3000;

/**
 * This util shows the toast taking the toast properties as an input object
 * @param item toast item details
 * @param shouldFocusOnToastButton indicate if the toast button should be focused on render
 */
export default function showToast(
    item: ToastItem,
    shouldFocusOnToastButton?: boolean,
    toastDivId: string = ''
): void {
    if (document.querySelector(`[id^="${TOAST_DIV_ID}"]`)) {
        // if any toast is already open, close the older sheet to reopen a new sheet to fix
        // BUG - https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/41652
        hideToast();
    }

    // create a div
    const toastId = TOAST_DIV_ID + toastDivId;
    const toastDiv = document.createElement('div');
    toastDiv.id = toastId;
    document.body.appendChild(toastDiv);

    changeIsToastShown(true); // set is shown to true

    const {
        label,
        retryLabel,
        retryButtonLabel,
        primaryButtonLabel,
        onPrimaryButtonClick,
        onTimeout,
        disableTimeout,
    } = item;
    let { timeoutInMilliSeconds } = item;

    // now render the item
    ReactDOM.render(
        <Toast
            item={item}
            onRetry={(remainingRetries: number) =>
                showToast({
                    ...item,
                    numberOfRetriesAllowed: remainingRetries,
                    label: retryLabel || label,
                    primaryButtonLabel: remainingRetries
                        ? retryButtonLabel || primaryButtonLabel
                        : null,
                    onPrimaryButtonClick: remainingRetries ? onPrimaryButtonClick : null, // so that we do not show the button after the last retry is done
                })
            }
            shouldFocusOnToastButton={shouldFocusOnToastButton}
        />,
        toastDiv
    );

    // We need a logic to automatically close this toast
    // Zero is also a valid value and hence we are explicitly checking for null or undefined
    if (timeoutInMilliSeconds === undefined || timeoutInMilliSeconds === null) {
        // means we have not deliberately set some value
        timeoutInMilliSeconds = TOAST_TIMEOUT_IN_MILLISECONDS;
    }

    !disableTimeout &&
        setTimerId(
            setTimeout(() => {
                hideToast();
                onTimeout?.();
            }, timeoutInMilliSeconds)
        );
}
